import { Inject } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { ofType } from '@ngrx/effects';
import { createEffect } from '@ngrx/effects';
import { toErrorMessage } from 'app/modules/main/helper/error-mapper';
import { AdvertiserTimeZoneService } from 'app/modules/main/services/advertiser-time-zone.service';
import { AdvertiserTimeZoneActions } from 'app/modules/main/store/advertiser-time-zone/advertiser-time-zone.actions';
import { LoadAdvertiserTimeZoneAction } from 'app/modules/main/store/advertiser-time-zone/advertiser-time-zone.actions';
import { UserAuthorizationSelectors } from 'app/modules/main/store/user-authorization/user-authorization.selectors';
import { EMPTY } from 'rxjs';
import { of } from 'rxjs';
import { first } from 'rxjs/operators';
import { exhaustMap } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AdvertiserTimeZoneEffects {

  static readonly LOAD =
    new InjectionToken<LoadAdvertiserTimeZoneAction[]>('LOAD');

  constructor(
    private readonly actions: Actions,
    private readonly advertiserTimeZoneService: AdvertiserTimeZoneService,
    private readonly userAuthorizationSelectors: UserAuthorizationSelectors,
    @Inject(AdvertiserTimeZoneEffects.LOAD)
    private readonly loadTimeZoneActions: LoadAdvertiserTimeZoneAction[],
  ) {
  }

  readonly load = createEffect(
    () => this.actions.pipe(
      ofType(...this.loadTimeZoneActions.flat()),
      exhaustMap(() => this.fetchAdvertiserTimeZone()),
    )
  );

  private fetchAdvertiserTimeZone() {

    return this.userAuthorizationSelectors.getOneAdvertiserId()
      .pipe(
        switchMap(advertiserId => this.advertiserTimeZoneService.fetch(advertiserId)),
        first(),
        map(AdvertiserTimeZoneActions.$.advertiserTimeZoneLoaded),
        catchError((error: any) =>
          error.status !== 0
            ? of(AdvertiserTimeZoneActions.$.advertiserTimeZoneLoadFailed(toErrorMessage(error)))
            : EMPTY
        ),
      );
  }

}
